'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dEdit$002dGrouping$002dPage$0024 from "./presto.-Edit-Grouping-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002455 from "./presto.-Presto-Router$$anon$55.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dId$0024 from "./presto.types$-Grouping-Id$.js";
import * as $j_presto$002etypes$0024$002dGrouping$002dName$0024 from "./presto.types$-Grouping-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$54() {
  this.bk5 = null;
  this.bjX = null;
  this.bjY = false;
  this.bk6 = null;
  this.bk7 = false;
  this.bka = null;
  this.bk3 = null;
  this.bk4 = false;
  this.bjZ = null;
  this.bk0 = false;
  this.bk1 = null;
  this.bk2 = false;
  this.bk8 = false;
  this.bk9 = false;
  this.bk5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bka = "EditGroupingPage";
}
export { $c_Lpresto_PrestoRouter$$anon$54 as $c_Lpresto_PrestoRouter$$anon$54 };
$p = $c_Lpresto_PrestoRouter$$anon$54.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$54;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$54() {
}
export { $h_Lpresto_PrestoRouter$$anon$54 as $h_Lpresto_PrestoRouter$$anon$54 };
$h_Lpresto_PrestoRouter$$anon$54.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bk5;
});
$p.L = (function() {
  if ((!this.bjY)) {
    this.bjX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bjY = true;
  }
  return this.bjX;
});
$p.O = (function() {
  if ((!this.bk7)) {
    this.bk6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bk7 = true;
  }
  return this.bk6;
});
$p.E = (function() {
  return this.bka;
});
$p.t = (function() {
  if ((!this.bk4)) {
    this.bk3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("name", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("global", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bk4 = true;
  }
  return this.bk3;
});
$p.M = (function() {
  if ((!this.bk0)) {
    this.bjZ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dId$0024.$m_Lpresto_types$GroupingId$().nK(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dGrouping$002dName$0024.$m_Lpresto_types$GroupingName$().nL(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().ar, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bk0 = true;
  }
  return this.bjZ;
});
$p.Q = (function() {
  if ((!this.bk2)) {
    this.bk1 = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002455.$c_Lpresto_PrestoRouter$$anon$55();
    this.bk2 = true;
  }
  return this.bk1;
});
$p.w = (function() {
  if ((!this.bk9)) {
    this.bk8 = false;
    this.bk9 = true;
  }
  return this.bk8;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee414) => ((p) => \u03b4scrutinee414.cFX(p)))($j_presto$002e$002dEdit$002dGrouping$002dPage$0024.$m_Lpresto_EditGroupingPage$())));
});
var $d_Lpresto_PrestoRouter$$anon$54 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$54, "presto.PrestoRouter$$anon$54", ({
  Ol: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$54 as $d_Lpresto_PrestoRouter$$anon$54 };
//# sourceMappingURL=presto.-Presto-Router$$anon$54.js.map
